import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { loadUser, OidcProvider } from 'redux-oidc';
import { LicenseManager } from 'ag-grid-enterprise';

import { ThemeProvider } from 'styled-components';
import store from './store';
import App from './components/containers/app';
import theme from './theme';
import StyleOverrides from './globalStyles';
import userManager from './helpers/userManager';
import TelemetryProvider from './helpers/telemetry-provider';
import { AG_GRID_LICENSE_KEY } from './env';

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

loadUser(store, userManager);

ReactDOM.render(
  <Provider store={store}>
    <OidcProvider userManager={userManager} store={store}>
      <BrowserRouter>
        <TelemetryProvider>
          <ThemeProvider theme={theme}>
            <StyleOverrides />
            <App />
          </ThemeProvider>
        </TelemetryProvider>
      </BrowserRouter>
    </OidcProvider>
  </Provider>,
  document.getElementById('root'),
);
